import { render, staticRenderFns } from "./UsernameSearch.vue?vue&type=template&id=01317ae0"
import script from "./UsernameSearch.vue?vue&type=script&lang=js"
export * from "./UsernameSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports